module.exports = __webpack_public_path__ + "img/Chime.6660f637.svg";